var _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,8.17a1.21,1.21,0,1,0,0-2.41h0a1.21,1.21,0,0,0,0,2.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.69,12.65a4,4,0,0,1-4,4H10.29a3.87,3.87,0,0,1-.77-.07L8,18.11a6,6,0,0,0,2.33.47h.61a.13.13,0,0,1,.13.13v1.21a.13.13,0,0,1-.13.12H7.76v2h8.49V20H13.11a.13.13,0,0,1-.13-.12V18.71a.13.13,0,0,1,.13-.13h.61a5.94,5.94,0,0,0,5.93-5.93V9.44h-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7,14.91a3.92,3.92,0,0,1-.72-2.26V9.44h-2v3.21a5.88,5.88,0,0,0,1.28,3.66Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.07,
    y: 10.96,
    width: 26.19,
    height: 2.08,
    transform: "translate(-4.96 12.02) rotate(-45.02)",
    className: "mic-off-line"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26,12.69a2.18,2.18,0,0,1-.21-.92V6a1.92,1.92,0,0,1,1.79-2h2.44a1.92,1.92,0,0,1,1.79,2v.89L16.74,5.2A3.67,3.67,0,0,0,13.28,2H10.84A3.78,3.78,0,0,0,7.31,6v5.79A4.3,4.3,0,0,0,7.93,14Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.07,11v.77a1.93,1.93,0,0,1-1.79,2h-1l-1.91,1.9a2.52,2.52,0,0,0,.47.06h2.44a3.79,3.79,0,0,0,3.53-4V9.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic-off.06e72f802c45f79f34cb7c231feb8fa5.svg";
export { ForwardRef as ReactComponent };